// Adapted from zion footer

import React, { lazy, Suspense } from 'react'
import { useOverlay } from '@fs/zion-ui'
import { css } from '@emotion/core'
import NavLinks from './NavLinks'
import LegalText from './LegalText'

const LangPicker = lazy(() => import('@fs/zion-lang-picker'))

const footerCss = css`
  padding: 0 24px 24px;
`

export default function Footer() {
  const [renderLangPicker, setRenderLangPicker] = React.useState(false)
  const overlay = useOverlay()
  const onLangClick = (event) => {
    setRenderLangPicker(true)
    overlay.handleClick(event)
  }

  return (
    <footer css={footerCss}>
      <div>
        <NavLinks onLangLinkClick={onLangClick} />
        <LegalText />
      </div>
      <Suspense fallback={<div />}>{renderLangPicker && <LangPicker overlay={overlay} />}</Suspense>
    </footer>
  )
}
